import { ALT_TEXT_MODAL_OPENED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { generateToolbarName } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { cloneElement, useCallback, useState } from 'react';
import { getWidgetTypeFromId } from 'widgets/Widget.helpers';

import { AltTextModal } from './AltTextModal';
import { AltTextModalTriggerProps } from './AltTextModal.types';

export const AltTextModalTrigger = ({
  widgetId,
  trigger,
  mpFrom,
  onClose = () => {},
  onOpen = () => {},
}: AltTextModalTriggerProps) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenAltTextModal = useCallback(() => {
    setModalOpen(true);
    onOpen?.();

    const widgetType = getWidgetTypeFromId(widgetId);
    let from = '';
    if (mpFrom) {
      from = mpFrom;
    } else {
      from = generateToolbarName(widgetType);
    }
    Mixpanel.track(ALT_TEXT_MODAL_OPENED.eventName, { from });
  }, [onOpen, widgetId, mpFrom]);

  const handleCloseAltTextModal = useCallback(() => {
    setModalOpen(false);
    onClose?.();
  }, [onClose]);

  return (
    <>
      {cloneElement(trigger, { onClick: handleOpenAltTextModal }, null)}
      <AltTextModal isOpen={isModalOpen} onClose={handleCloseAltTextModal} widgetId={widgetId} />
    </>
  );
};
